import React from 'react';
import { Route } from 'react-router-dom';
import { Switch } from 'react-router';
import EditerCeaf from './editer/EditerCeaf';
import VisualiserCeaf from './visualiser/VisualiserCeaf';
import RoutesCeaf from './routes';
import RouteSecurisee from '../../../../components/RouteSecurisee/RouteSecurisee';
import { DROITS_EDITER_CEAF } from '../../../../utils/droitsEtRoles.constant';
import { getPath } from '../../../../utils/router';

const Ceaf = () => {
    return (
        <div>
            <Switch>
                <RouteSecurisee
                    path={getPath(RoutesCeaf.subroutes.editer)}
                    render={(subProps) => <EditerCeaf {...subProps} />}
                    droits={DROITS_EDITER_CEAF}
                />
                <Route
                    path={getPath(RoutesCeaf.subroutes.visualiser)}
                    render={(subProps) => <VisualiserCeaf {...subProps} />}
                />
            </Switch>
        </div>
    );
};

Ceaf.propTypes = {};

export default Ceaf;
